import React, {Component} from 'react';
import {Link} from 'react-router';
import Translate from '../layout/Translate';

export default class Review extends Component {


    componentDidUpdate () {
        let actions = this.props.actions;

        //console.log(this.props.user);
        if (this.props.user.review && this.props.user.review.promise) {

            this.props.user.review.promise.json().then(function (result) {

                //console.info('result')
                //console.info(result)

                actions.setReviewResult(result);
            });
        }
    }

    componentWill


    componentWillMount() {
        this.messageParams = {
            name: '',
            email: '',
            text: '',
            lang: this.props.user.lang,
            rating: 0

        };

    }

    componentWillReceiveProps(nextProps) {
        this.nextProps = nextProps;
    }


    send() {
        if (!this.props.load) {
            this.messageParams.rating = (this.props.user.reviewRating)?this.props.user.reviewRating:0;
            this.messageParams.url = this.nextProps.path.location.pathname;
            this.props.actions.sendReview(this.messageParams);
        }
    }

    changeInfo(field, e) {
        this.messageParams[field] = e.target.value;
    }
    mouseMove(rating) {
        this.props.actions.hoverRating(rating);
    }

    changeRating(rating) {
        this.props.actions.changeReviewRating(rating+1);
    }

    handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.send();
        }
    }


    toggleModal() {
        this.props.actions.toggleReview();
    }

    render() {

        let success = false;
        if (this.props.user.review && this.props.user.review.success) {
            success = true;
        }

        let errors = {};
        if (this.props.user.review && this.props.user.review.result && this.props.user.review.result.length) {
            this.props.user.review.result.forEach(function(error){
                errors[error.field] = true;
            });
        }


        let rating = [];
        let ratingValue = (this.props.user.rating && this.props.user.rating.hoverRating)?this.props.user.rating.hoverRating:this.props.user.reviewRating;

        for (var i=0; i < 5; i++) {
            rating.push(
                <div className={"rate__star rate__star_black " + ((ratingValue > i)?"rate__star_active":"")}
                     onMouseEnter={this.mouseMove.bind(this, i+1)}
                     onMouseLeave={this.mouseMove.bind(this, this.props.user.reviewRating)}
                     onClick={this.changeRating.bind(this, i)}
                ></div>
            );
        }

        return (
            <div>
                {false &&
                <div className={"popup " + (this.props.open ? 'popup_active' : '')}>


                    <div className="popup__window popup__window_feedback feedback">
                        <div className="feedback__title feedback__title_texted">
                            <Translate slug="review__title"/>
                        </div>
                        <div className="popup__close" onClick={this.toggleModal.bind(this)}></div>
                        {!success &&
                        <div>
                            <p className="feedback__text"><Translate slug="review__text"/></p>
                            <div className="feedback__row">
                                <label className="feedback__label"><Translate slug="review__rating"/></label>
                                <div className="feedback__rate rate">
                                    {rating}
                                </div>
                            </div>

                            <div className="feedback__row">
                                <label className="feedback__label"><Translate slug="review__question"/></label>
                                <textarea
                                    className={"feedback__textarea " + (errors['text'] ? 'feedback__textarea_error' : '')}
                                    onChange={this.changeInfo.bind(this, 'text')}
                                ></textarea>
                            </div>

                            <div className="feedback__row">

                                <label className="feedback__label"><Translate slug="review__name"/></label>
                                <input className={"feedback__field " + (errors['name'] ? 'feedback__field_error' : '')}
                                       onChange={this.changeInfo.bind(this, 'name')}
                                       onKeyPress={this.handleKeyPress.bind(this)}/>
                            </div>
                            <div className="feedback__row">
                                <label className="feedback__label"><Translate slug="review__email"/></label>
                                <input className={"feedback__field " + (errors['email'] ? 'feedback__field_error' : '')}
                                       onChange={this.changeInfo.bind(this, 'email')}
                                       onKeyPress={this.handleKeyPress.bind(this)}/>
                                <div className="feedback__comment">
                                    <Translate slug="review__email-comment"/>
                                </div>
                            </div>


                            <div className="feedback__row">
                                <input type="submit"
                                       className={"feedback__button " + (this.props.load ? 'feedback__button_progress' : '')}
                                       value={this.props.translations["review__send"]} onClick={this.send.bind(this)}/>
                            </div>
                        </div>
                        }
                        {success &&
                        <div className="feedback__success"><Translate slug="review__complete"/></div>
                        }

                    </div>


                </div>
                }
            </div>


        );
    }
}



// WEBPACK FOOTER //
// ./src/common/components/popups/Review.js